var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import md5 from "md5";
import querystring from "query-string";
import { generateTestId } from "../../../utils";
import { Text } from "../../Text";
import { StyledAvatarIcon, StyledAvatarPlaceholder, StyledImage, getSize } from "./styled";
import useLoadAvatar from "./useLoadAvatar";
var getGravatarUrl = function (_a) {
    var size = _a.size, email = _a.email;
    var base = "https://www.gravatar.com/avatar/";
    var query = querystring.stringify({
        s: getSize(size),
        r: "g",
        d: "404"
    });
    // Gravatar service currently trims and lowercases all registered emails
    var formattedEmail = email.trim().toLowerCase();
    var hash = md5(formattedEmail);
    return "".concat(base).concat(hash, "?").concat(query);
};
var Avatar = function (_a) {
    var id = _a.id, className = _a.className, style = _a.style, _b = _a.name, name = _b === void 0 ? "" : _b, _c = _a.email, email = _c === void 0 ? "" : _c, _d = _a.alt, alt = _d === void 0 ? "Avatar for ".concat(name || email || "user") : _d, _e = _a.size, size = _e === void 0 ? "medium" : _e, _f = _a.src, src = _f === void 0 ? "" : _f, _g = _a.variant, variant = _g === void 0 ? "primary" : _g;
    var _h = useLoadAvatar(src), isAvatarImageLoaded = _h.loaded, avatarImageSrc = _h.imageSrc, hasAvatarImageError = _h.error;
    var _j = useLoadAvatar(getGravatarUrl({ size: size, email: email })), isGravatarImageLoaded = _j.loaded, gravatarImageSrc = _j.imageSrc, hasGravatarImageError = _j.error;
    // Avatar Image
    if (src && isAvatarImageLoaded && !hasAvatarImageError) {
        return (React.createElement(StyledImage, __assign({ id: id, className: className, style: style, size: size, src: avatarImageSrc, alt: alt }, generateTestId("avatar-image"), generateTestId("avatar"))));
    }
    // Gravatar Image
    if (email && isGravatarImageLoaded && !hasGravatarImageError) {
        return (React.createElement(StyledImage, __assign({ size: size, src: gravatarImageSrc, alt: alt || "Avatar for ".concat(name || email || "user") }, generateTestId("gravatar-image"), generateTestId("avatar"))));
    }
    // Avatar Icon
    if (name) {
        var spacePosition = name.indexOf(" ");
        return (React.createElement(StyledAvatarIcon, __assign({ size: size, variant: variant }, generateTestId("avatar-icon"), generateTestId("avatar")), spacePosition > 0 ? (React.createElement(Text, { style: style, variant: "label", color: "inherit" }, "".concat(name.charAt(0)).concat(name.charAt(spacePosition + 1)))) : (React.createElement(Text, { style: style, variant: "avatar", color: "inherit" }, "".concat(name.charAt(0))))));
    }
    // Avatar Placeholder
    return (React.createElement(StyledAvatarPlaceholder, __assign({ size: size }, generateTestId("avatar-placeholder"), generateTestId("avatar"))));
};
export default Avatar;
//# sourceMappingURL=Avatar.js.map